import { createContext } from 'use-context-selector';
import { IVGSFormContextValues } from 'obt-common/src/types/payments/vgs';

export const VGSFormContext = createContext<IVGSFormContextValues>({
  formMap: {},
});
